import { InsuranceAction, InsuranceActionListenerList, LegacyInsuranceAction } from '@typesApp/InsuranceActionListener'
import { logger } from '@utils/logger'

export const invokeInsuranceActionListeners = (
  listenerList: InsuranceActionListenerList | undefined,
  action: InsuranceAction
) => {
  const listeners = listenerList?.listeners ?? []
  const isLegacy = listenerList?.isLegacy

  listeners.length && logger.debug('Invoking %s insurance action listener(s)', listeners.length)

  const insuranceAction = mapAction(action, isLegacy)
  try {
    listeners.forEach(handler => typeof handler === 'function' && handler(insuranceAction))
  } catch (error) {
    logger.warn('Error invoking insurance action listener', error)
  }
}

/**
 * Ensure we send the correct action as existing brands expect 'sync' whereas newer integrations expect 'apply'.
 * Once all integrations are up to date, we can remove the mapping.
 */
const mapAction = (action: InsuranceAction, isLegacy?: boolean): InsuranceAction | LegacyInsuranceAction => {
  if (action === 'apply' && isLegacy) {
    return 'sync'
  }
  return action
}
